export const vietnamExpressPackage = {
  id: "vietnam-express-9d8n",
  title: "Vietnam Express",
  country: "Vietnam",
  days: 9,
  nights: 8,
  price: "₹1,32,900 per adult + 5% GST + 5% TCS",
  thumbnail:
    "https://images.pexels.com/photos/2161449/pexels-photo-2161449.jpeg", // Vietnam scenic image
  description:
    "Experience the best of Vietnam in 9 days – from Hanoi’s old-world charm to Halong Bay’s limestone wonders, from the ancient town of Hoi An and the iconic Golden Bridge at Ba Na Hills to the bustling streets of Ho Chi Minh City and the serene Mekong Delta. This journey combines history, culture, and breathtaking landscapes.",

  highlights: [
    "Guided city tour of Hanoi",
    "Cruise & overnight stay at Halong Bay",
    "Visit Marble Mountain, Hoi An & Lantern Boat Trip",
    "Explore Golden Bridge & Ba Na Hills via cable car",
    "Visit Cu Chi Tunnels and learn about Vietnam War history",
    "Mekong Delta boat experience with local village visit",
  ],

  included: [
    "Return economy class airfare from Mumbai",
    "Visa as per itinerary",
    "Accommodation on twin sharing basis",
    "Daily meals (as per itinerary: Breakfast, Lunch, Dinner)",
    "Travel insurance (upto 60 years)",
    "All transfers & sightseeing in coach",
    "Entrance fees at monuments mentioned",
    "Tour Manager services throughout the tour",
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Hanoi – PM City Tour",
      description:
        "Arrive at Noi Bai Airport, transfer to hotel. Afternoon visit Temple of Literature, Ngoc Son Temple, Hoan Kiem Lake, and enjoy a cyclo ride through Old Quarter. Lunch & dinner at Indian restaurant. Overnight in Hanoi.",
      photo: "https://images.pexels.com/photos/19592021/pexels-photo-19592021.jpeg",
    },
    {
      day: 2,
      title: "Hanoi – Ninh Binh – Hoa Lu & Trang An",
      description:
        "Travel to Hoa Lu to explore Vietnam’s ancient capital. Visit Dinh and Le Temples. Afternoon sampan boat ride through Trang An ecological site with caves and valleys. Overnight in Hanoi.",
      photo: "https://images.pexels.com/photos/32700715/pexels-photo-32700715.jpeg",
    },
    {
      day: 3,
      title: "Hanoi – Halong Bay (Overnight Cruise)",
      description:
        "Drive to Halong Bay, board the cruise, visit fishing villages, enjoy seafood dinner under the stars. Overnight on cruise.",
      photo: "https://images.pexels.com/photos/58597/pexels-photo-58597.jpeg",
    },
    {
      day: 4,
      title: "Halong Bay – Hanoi – Flight to Danang",
      description:
        "Morning cave visit & brunch on cruise. Return to Hanoi for late afternoon flight to Danang. Dinner at Indian restaurant. Overnight in Danang.",
      photo: "https://images.pexels.com/photos/19328627/pexels-photo-19328627.jpeg",
    },
    {
      day: 5,
      title: "Danang – Marble Mountain, Hoi An & Lantern Boat",
      description:
        "Visit Marble Mountain & Linh Ung Pagoda. Afternoon basket boat tour in Cam Thanh village. Explore Hoi An Ancient Town and lantern boat trip. Overnight in Danang.",
      photo: "https://images.pexels.com/photos/5746254/pexels-photo-5746254.jpeg",
    },
    {
      day: 6,
      title: "Danang – Golden Bridge & Ba Na Hills",
      description:
        "Cable car ride to Ba Na Hills. Visit Golden Bridge, French Village, gardens, pagodas, Fantasy Park, and more. Overnight in Danang.",
      photo: "https://images.pexels.com/photos/2582794/pexels-photo-2582794.jpeg",
    },
    {
      day: 7,
      title: "Flight to Ho Chi Minh City – Cu Chi Tunnels",
      description:
        "Morning flight to Ho Chi Minh City. Afternoon visit Cu Chi Tunnels – the underground network from Vietnam War. Overnight in Ho Chi Minh City.",
      photo: "https://images.pexels.com/photos/32331813/pexels-photo-32331813.jpeg",
    },
    {
      day: 8,
      title: "Mekong Delta (My Tho)",
      description:
        "Boat ride through islands, sampan rowboat ride, coconut candy workshop, tropical fruits, honey tea, traditional music. Visit Vinh Trang Pagoda. Return to Ho Chi Minh City. Overnight stay.",
      photo: "https://images.pexels.com/photos/1660996/pexels-photo-1660996.jpeg",
    },
    {
      day: 9,
      title: "Ho Chi Minh City Tour & Departure",
      description:
        "Guided city tour: Reunification Palace, Notre Dame Cathedral, Old Post Office, Ben Thanh Market. Transfer to airport for onward flight.",
      photo: "https://images.pexels.com/photos/1018478/pexels-photo-1018478.jpeg",
    },
  ],

  gallery: [
    "hhttps://images.pexels.com/photos/19592021/pexels-photo-19592021.jpeg",
    "https://images.pexels.com/photos/32700715/pexels-photo-32700715.jpeg",
    "https://images.pexels.com/photos/58597/pexels-photo-58597.jpeg",
    "https://images.pexels.com/photos/19328627/pexels-photo-19328627.jpeg",
    "https://images.pexels.com/photos/5746254/pexels-photo-5746254.jpeg",
    "https://images.pexels.com/photos/2582794/pexels-photo-2582794.jpeg",
    "https://images.pexels.com/photos/32331813/pexels-photo-32331813.jpeg",
    "https://images.pexels.com/photos/1660996/pexels-photo-1660996.jpeg",
    "hhttps://images.pexels.com/photos/1018478/pexels-photo-1018478.jpeg",
    "https://images.pexels.com/photos/2796627/pexels-photo-2796627.jpeg",
    "https://images.pexels.com/photos/2965773/pexels-photo-2965773.jpeg",
    "https://images.pexels.com/photos/1368562/pexels-photo-1368562.jpeg",
    "https://images.pexels.com/photos/2993128/pexels-photo-2993128.jpeg",
    "https://images.pexels.com/photos/4652275/pexels-photo-4652275.jpeg"
  ],

  groupDates: [
    { group: "Group 1", start: "2025-10-07", end: "2025-10-15" },
    { group: "Group 2", start: "2026-01-10", end: "2026-01-18" },
    { group: "Group 3", start: "2026-02-12", end: "2026-02-20" },
  ],

  brochure:
    "https://firebasestorage.googleapis.com/v0/b/paryatakadmin.firebasestorage.app/o/packages%2Fvietnam_express_brochure.pdf?alt=media&token=example",

  rating: {
    stars: 4.9,
    reviews: 180,
  },

  reviews: [
    {
      stars: 5,
      review: "Unforgettable experience! The cruise in Halong Bay was magical.",
      name: "Priya Nair",
    },
    {
      stars: 4,
      review: "Well-organized tour with great Indian meals provided throughout.",
      name: "Suresh Iyer",
    },
    {
      stars: 5,
      review: "The Golden Bridge and Mekong Delta visit were simply amazing!",
      name: "Aditi Sharma",
    },
  ],
};
